import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-parameters',
  storeModule.createStoreModule('real-estate-developments-parameters')
)
